<script>

import axios from 'axios';

const mainUrl = process.env.VUE_APP_API_URL;

export default class ListaDeAgendamentosRepository{
    
    async getListas(page,token,rawdata){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data,{ headers: headers });
        return response;

    }

    async createLista(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteLista(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getLista(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async updateLista(page, token, id, rawdata) {
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.put(baseURL, rawdata, { headers });
        return response;
    }

    async vincularEmpresaLista(id,token,rawdata){

        const baseURL = `${mainUrl}agendamentos/${id}/vincular-empresa`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.post(baseURL, rawdata, { headers });
        return response;
       
    }

    async desvincularEmpresaLista(id,token){

        const baseURL = `${mainUrl}agendamento/vinculo-empresa/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.delete(baseURL, { headers });
        return response;
       
    }

    async getPlanosDisponiveis(id,token){

        const baseURL = `${mainUrl}agendamentos/${id}/planos-disponiveis`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.get(baseURL, { headers });
        return response;
       
    }

    async getListaWhatsApp(id,token){

        const baseURL = `${mainUrl}agendamentos/lista-whatsApp/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.get(baseURL, { headers });
        return response;
       
    }


}
</script>
